import React, { createContext, useContext, useEffect, useState } from 'react';

const STORAGE_KEY = 'saver-ui-version';
const DEFAULT_VERSION = 'v3';

const UIVersionContext = createContext({
  version: DEFAULT_VERSION,
  setVersion: () => {},
});

export const UIVersionProvider = ({ children }) => {
  const [version, setVersionState] = useState(() => {
    try {
      return localStorage.getItem(STORAGE_KEY) || DEFAULT_VERSION;
    } catch {
      return DEFAULT_VERSION;
    }
  });

  const setVersion = (next) => {
    setVersionState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {}
  };

  useEffect(() => {
    document.documentElement.setAttribute('data-ui-version', version);
  }, [version]);

  return (
    <UIVersionContext.Provider value={{ version, setVersion }}>
      {children}
    </UIVersionContext.Provider>
  );
};

export const useUIVersion = () => useContext(UIVersionContext);
